<template>
  <section>
    <MemberToast
      v-if="showMerbersPopup && Number(maxLevel) > 0"
      v-model="showMerbersPopup"
      :levelCode="Number(maxLevel)"
      :couponList="couponList"
      :kgoldList="kgoldList"
      :kgoldTotal="kgoldTotal"
      @onShare="onShare"
      @close="close"
    />
    <ShareDialog
      v-model="showShareDialog"
      :levelCode="Number(maxLevel)"
      from="toast"
    />
  </section>
</template>
<script>
  // 会员升级弹窗
  import MemberToast from './MemberToast.vue'
  import ShareDialog from '../ShareDialog/index'
  import { getCouponList } from '@/api/fission'
  import { getMemberWindow } from '@/api/member'
  import { mapState } from 'vuex'
  import { PQ, Message } from '@/utils/priorityQueue'
  import { isJsonString } from '@/utils/tool'
  import { isMsaWebView } from '@/utils/msa'
  import { filtrateCouponIds } from '@/utils/members'
  import { storage, MembersModalBoxList } from '@/utils/storage'

  const popup_id = 'merbers-popup'

  // todo 防止watch 请求多次
  let look = true
  let isRepeat = true

  export default {
    name: 'ModalBox',
    components: {
      MemberToast,
      ShareDialog,
    },
    data() {
      return {
        couponList: [], // 优惠券列表
        upgradeCouponList: [], // 优惠券 ：底部显示 升级xx元
        kgoldList: [], // kgoldList
        kgoldTotal: 0, // 共计数量
        showMerbersPopup: false, // 显示升级弹窗
        showShareDialog: false, // 显示分享弹窗
        currency: '', // 货币符号、接口返回
        maxLevel: '', // 当前最大等级
      }
    },
    mounted() {
      // msa屏蔽云控弹窗
      if (isMsaWebView()) return
      this.init()
      Message.receive((res) => {
        const { id } = res || {}

        if (id === popup_id) {
          this.showMerbersPopup = true
          PQ.open(popup_id)
        }
      })
    },
    destroyed() {
      look = true
      isRepeat = true
      PQ.close(popup_id)
    },
    computed: {
      ...mapState([
        'userInfo',
        'region',
        'members',
        'isTurbo',
        'allowUseMember',
      ]),
    },
    watch: {
      members: {
        handler(newVal) {
          const { userInfo } = newVal
          this.maxLevel = userInfo?.levelCode || ''
        },
        deep: true,
        immediate: true,
      },
      userInfo: {
        handler(newVal) {
          if (newVal && newVal.kicoinId && look) {
            this._setMemberBirthday(newVal)
            look = false
          }
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
      init() {
        const userInfo = this.userInfo
        const members = this.members

        if (!userInfo || !members) return
        this._setMemberBirthday(userInfo)
      },

      close() {
        PQ.close(popup_id)
        this.$emit('close')
      },

      onShare() {
        const timeId = setTimeout(() => {
          clearTimeout(timeId)
          this.showShareDialog = true
        }, 200)
      },

      // 获取弹层接口数据
      async _setMemberBirthday(data) {
        try {
          const { kicoinId = '' } = data

          if (!kicoinId) return
          if (!this.allowUseMember) return

          if (isRepeat) {
            isRepeat = false
            const result = await getMemberWindow(kicoinId)
            const { list } = this.getMemberModalData(result)

            // 更新弹层的数据集合
            storage.set(MembersModalBoxList, list)

            this.renderKgolds(list)
            this.renderCoupons(list)

            if (list.length > 0) {
              PQ.enqueue({
                id: popup_id,
                priority: 4,
              })
            }
          }
        } catch (error) {
          window.console.warn(
            '%c[_setMemberBirthday]方法报错',
            'color:#0f0',
            error
          )
        }
      },

      // 获取弹层的数据
      getMemberModalData(data) {
        let result = {
          list: [], // type = 1 : 优惠券; type = 2 : KB
        }

        if (data.length) {
          result.list = data.map((item) => {
            if (item.messageBody && isJsonString(item.messageBody)) {
              item.messageBody = JSON.parse(item.messageBody)
            }
            return item
          })
        }
        return result
      },

      // 获取 优惠券数据
      async _getCouponList(couponIdString, _couponIds) {
        const country = this.region
        try {
          const couponList = await getCouponList({
            country,
            couponIdString,
          })
          this.type = couponList.length ? 1 : 2
          this.couponList = couponList
          this.upgradeCouponList = filtrateCouponIds(_couponIds, couponList)
        } catch (error) {
          window.console.warn('%c[_getCouponList]方法报错', 'color:#0f0', error)
        }
      },

      // 优惠券的关闭事件
      closedMembersDialog() {
        this.showMerbersPopup = false
        PQ.close(popup_coupon_id)
      },

      // 渲染优惠券列表
      // todo 为了 保持弹层的顺序、优惠券的弹层数据拿取的是VUEX的值
      renderCoupons(list = []) {
        let data = list

        if (!data || !data.length) return
        const result = data.filter((item) => item.messageBody.type === 1)
        if (!result.length) return

        let couponIds = result.reduce((prev, curv) => {
          const { content = '' } = curv.messageBody
          if (content) {
            prev += `${content},`
          }
          return prev
        }, '')

        const _couponIds = result.map((item) => {
          let data = {
            levelCode: item.messageBody.levelCode,
            couponIds: item.messageBody.content
              ? item.messageBody.content.split(',')
              : [],
          }
          return data
        })
        couponIds = couponIds.slice(0, couponIds.length - 1)
        this._getCouponList(couponIds, _couponIds)
      },

      // 渲染Kgold数据
      renderKgolds(data) {
        if (!data.length) return
        const result = data.filter((item) => item.messageBody.type === 2)
        if (!result.length) return

        // KB金额汇总
        const total = result.reduce((prev, curv) => {
          prev += curv.messageBody.content * 1
          return prev
        }, 0)
        this.kgoldList = result
        this.kgoldTotal = total
        this.currency = result[0].currency
      },
    },
  }
</script>
<style scoped lang="scss" src="./index.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
